import { ApiResult, httpRequest, Urls } from './Shared';

const ROLE_URL = '/Roles';

export interface Role {
    name: string;
    id: number;
}

export interface RolesAndPermissions {
    roles: { id: number, name: string }[];
    permissions: { id: number, name: string }[];
}

export const getRoles = (): Promise<ApiResult<Role[]>> => {
    return httpRequest<Role[]>(`${Urls.BASE_URL}${ROLE_URL}`, 'get');
};

export const getRolesAndPermissions = (): Promise<ApiResult<RolesAndPermissions[]>> => {
    return httpRequest<RolesAndPermissions[]>(`${Urls.BASE_URL}${ROLE_URL}/rolesandpermissions`, 'get');
};


// WEBPACK FOOTER //
// ./src/api/Role.ts